module.exports = __webpack_public_path__ + "5331b3218da895df0c0082f7ce7117b6.glb";